import { useRef, useEffect } from 'react';

export function useDidUpdate() {
  const ref = useRef(false);

  useEffect(() => {
    ref.current = true;
  }, []);

  return !!ref.current;
}
